import { z } from "zod";

import {
  createMutationRequestDefinition,
  createQueryRequestDefinition,
} from "~/lib/network/definitions/create";
import { queryClient } from "~/lib/query-client";

import {
  listReviewFeedbackResponseSchema,
  reviewFeedbackSubmissionSchema,
  reviewFeedbackTargetSchema,
} from "./schemas";

const FEEDBACK_PAGE_SIZE = 50;

export const fetchCapCodeReviewFeedbackQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "capcode-review", "feedback-list"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/capcode-review/feedback",
  paramsSchema: z.object({
    limit: z.number().min(1).max(100).optional().default(FEEDBACK_PAGE_SIZE),
    afterCursor: z.string().optional(),
  }),
  responseSchema: listReviewFeedbackResponseSchema,
}).withPagination({
  getNextPageParam(lastPage) {
    return lastPage.pageInfo.hasNextPage ? (lastPage.pageInfo.endCursor ?? undefined) : undefined;
  },
  mapPaginationParamsToQueryParams({ pageParam }) {
    return {
      limit: FEEDBACK_PAGE_SIZE,
      ...(pageParam ? { afterCursor: pageParam } : {}),
    };
  },
});

export const getCapCodeReviewFeedbackTargetQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "capcode-review", "feedback"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/capcode-review/feedback/:feedbackId",
  paramsSchema: z.object({}).default({}),
  responseSchema: reviewFeedbackTargetSchema,
});

export const submitCapCodeReviewFeedbackMutation = createMutationRequestDefinition({
  host: "cap-srv",
  method: "POST",
  path: "/proxy/oasis/camel/capcode-review/feedback/:feedbackId",
  paramsSchema: z.object({
    feedback: z.string().trim().min(1).max(2000),
  }),
  responseSchema: reviewFeedbackSubmissionSchema,
  onSuccess() {
    void Promise.all([
      getCapCodeReviewFeedbackTargetQuery.invalidateAllQueries(queryClient),
      fetchCapCodeReviewFeedbackQuery.invalidateAllQueries(queryClient),
    ]);
  },
});
